import StateManager from './StateManager';
import $ from 'jquery';
import Q from 'q';
import _ from 'underscore';

/* --------------------------------------------------

    LAYOUT

-------------------------------------------------- */

var HorizontalLayout = function(options) {
    this.options = _.defaults({}, options, {
        leftWidth: 60,
        rightWidth: 40,
    });
};

$.extend(HorizontalLayout.prototype, {

    name: 'HorizontalLayout',

    bodyClass: 's-desktop',

    isAvailable: function() {
        // return true;
        return $(window).width() > 960;
    },

    activate: function() {
        this.scroll = new Scroll(this);
        this.arrows = new Arrows(this);
        this.head   = new Head(this);
        this.menu   = new Menu(this);
        this.menuOverlay   = new MenuOverlay(this);

        var self = this;
        return Q.fcall(function(){
          self.scroll.activate();
          self.arrows.activate();
          self.head.activate();
          self.menu.activate();
          self.menuOverlay.activate()
        });
    },

    deactivate: function() {
        this.scroll.deactivate();
        this.arrows.deactivate();
        this.head.deactivate();
        this.menu.deactivate();
        this.menuOverlay.deactivate();

        var self = this;
        return Q.fcall(function(){
          self.scroll = null;
          self.arrows = null;
          self.head = null;
          self.menu = null;
          self.menuOverlay = null;
        });
    },

});



/* --------------------------------------------------

    GESTIONNAIRE DU SCROLL

-------------------------------------------------- */

var Scroll = function(layout) {
    this.layout = layout;
};


$.extend(Scroll.prototype, {

    activate: function() {
        this._scrollTarget = -1;

        this.$window = $(window);
        this.$scroller =  $('html,body');
    },

    deactivate: function() {
        this.$scroller.stop(true);
    },

    to: function(newTarget, duration) {
        if (duration === undefined) duration = 600;

        // on y va déjà !
        if (newTarget === this._scrollTarget) return;

        var min = 0;
        var max = this.maxScrollLeft();
        var current = this.scrollLeft();

        if (newTarget < min) newTarget = min;
        if (newTarget > max) newTarget = max;

        if (newTarget === current) {
            this.$scroller.stop(true);
            return;
        }

        this._scrollTarget = newTarget;

        var self = this;
        this.$scroller.stop(true).animate({
            scrollLeft: this._scrollTarget,
        }, duration, /*'linear',*/ function() {
            self._scrollTarget = -1;
        });
    },

    scrollLeft: function() {
        return this.$window.scrollLeft();
    },

    maxScrollLeft: function() {
        return this.documentWidth() - this.$window.width();
    },

    documentWidth: function() {
        var scrollWidth = 0;
        var widths = [
            document.width,
            document.body.scrollWidth,
            document.documentElement.scrollWidth,
        ];

        var i = 0;
        var n = widths.length;
        var width;

        for (i; i<n; i++) {
            width = parseInt(widths[i]);
            if (width > scrollWidth) scrollWidth = width;
        }

        return scrollWidth;
    },

});



/* --------------------------------------------------

    GESTIONNAIRE DU HEADER

-------------------------------------------------- */

var Head = function(layout) {
    this.layout = layout;
	// fix: décale le calcul du scroll pour laisse le temps aux menu de s'ouvrir
    this._stateChangeHandler = _.debounce(this._stateChangeHandler);
};

$.extend(Head.prototype, {

    activate: function() {
        // variables
        this._headIsCollapsed = false;

        // éléments du dom
        this.$window = $(window);
        this.$body   = $(document.body);
        this.$head   = $('.js-scuba__head').first();
        this.$main   = $('.js-scuba__main').first();
        this.$menu   = this.$head.find('.js-scuba__menu').first();
        this.menu    = this.$menu.data('ScubaMenuController');


        // init le horizontal layout
       window.__HorizontalLayout_preventNextAutoScroll = false;

        // écouteurs
        this.$head.find('a').on('click', $.proxy(this._linkClickHandler, this));
        this.$window.on('scuba:pushState', $.proxy(this._pushStateHandler, this));
        this.$window.on('scuba:stateChange', $.proxy(this._stateChangeHandler, this));
        this.$head.on('scuba:nextPagesChanged', $.proxy(this._nextPagesChangedHandler, this));

        // Todo: A nettoyer. Règle le problème des animations css
        var self = this;
        setTimeout(function() {
            var state = StateManager.getCurrentState(true);
            self.$head.addClass('animate');
            self._nextPagesChangedHandler(null, state);
            self._stateChangeHandler(null, state);
        }, 100);
    },

    deactivate: function() {
        this.$head.find('a').off('click', $.proxy(this._linkClickHandler, this));
        this.$window.off('scuba:pushState', $.proxy(this._pushStateHandler, this));
        this.$window.off('scuba:stateChange', $.proxy(this._stateChangeHandler, this));
        this.$head.off('scuba:nextPagesChanged', $.proxy(this._nextPagesChangedHandler, this));
    },

    _linkClickHandler: function(/*event*/) {
        // this.expand();
    },

    _pushStateHandler: function(/*event, pageFromUrl*/) {
        // WIP: je vais décaler ça après le state change
        /*if (pageFromUrl) {
            var $page = this.$main.find('.page[data-url="'+pageFromUrl+'"]');
            var $firstPage = this.$main.find('.page:eq(0)');
            this.layout.scroll.to($page.offset().left - $firstPage.offset().left);
            this.collapse();
        }*/
    },

    _stateChangeHandler: function(event, state) {
        if (!state || !state.length) return;

        //
        if (window.__HorizontalLayout_preventNextAutoScroll) {
          window.__HorizontalLayout_preventNextAutoScroll = false;
          return;
        }
        // retire toutes les pages après la cible
        var currentFound = false;
        state = _.filter(state, function(page) {
            return page.isCurrent ? (currentFound = true) : !currentFound;
        }, this);


        // première page
        var first = _.first(state);
        var firstLeft = first.$element.offset().left;

        // coordonnées de la fenêtre d'affichage
        var winLeft = this.layout.scroll.scrollLeft() + this.layout.options.leftWidth;
        var winWidth = this.$window.width() - this.layout.options.leftWidth - this.layout.options.rightWidth;

        // console.log('VIEWPORT', 'x:'+winLeft, 'width:'+winWidth);

        // coordonnées qu'on va essayer d'afficher
        var focusLeft, focusWidth;

        // détermine les points de scroll potentiels (uniquement ceux
        // relatifs aux pages de contenu)
        var breaks = [];
        var isHome = 0;
        _.each(state, function(page) {
            breaks.push(page.$element.offset().left);
            if (page.$element.is('.is-home-page')) {
                isHome ++;
            }
            if (page.$element.is(':has(.js-scuba__cover)')) {
                breaks.push(page.$element.find('.js-scuba__section__body').offset().left);
                page.$element.find('.js-scuba__submenu').each(function(i, el) {
                    breaks.push($(el).offset().left);
                });
            }
            if (page.$element.is(':has(.has-form-left)')) {
               breaks.push(page.$element.find('.js-scuba__list__items').offset().left);
            }
        }, this);

        // si on est à l'acceuil, on veut voir le menu !
        if (isHome && isHome === state.length) {
            this.layout.scroll.to(0);
            return;
        }

        if (state.length == 1) {
            // s'il n'y a qu'une page, on ajoute les points de scroll du menu
            _.each(this.menu.$sections.get().reverse(), function(sections) {
                breaks.unshift($(sections).offset().left);
            }, this);

            var $lastMenu = this.menu.$sections.last();
            if ($lastMenu.length) {
                focusLeft = $lastMenu.offset().left;
                focusWidth = $lastMenu.outerWidth() + getPageWidth(first.$element);
            } else {
                focusLeft = firstLeft;
                focusWidth = getPageWidth(first.$element);
            }
        }
        else if (state.length >= 2) {
            // dernière page
            var last = state[state.length - 1];
            var lastWidth = getPageWidth(last.$element);

            // avant dernière page
            var prev = state[state.length - 2];
            var prevLeft, prevWidth;
            if (prev.$element.is(':has(.js-scuba__cover)')) {
                if (prev.$element.is(':has(.js-scuba__submenu)')) {
                    var $lastSubmenu = prev.$element.find('.js-scuba__submenu').last();
                    prevLeft = $lastSubmenu.offset().left;
                    prevWidth = $lastSubmenu.outerWidth();
                } else {
                    var $coverBody = prev.$element.find('.js-scuba__section__body');
                    prevLeft = $coverBody.offset().left;
                    prevWidth = $coverBody.outerWidth();
                }
            } else if (prev.$element.is(':has(.has-form-left)')) {
                    var $list = prev.$element.find('.js-scuba__list__items');
                    prevLeft = $list.offset().left;
                    prevWidth = $list.outerWidth();
                    // console.log("list-items l="+prevLeft+" w="+prevWidth);
            } else {
                prevLeft = prev.$element.offset().left;
                prevWidth = getPageWidth(prev.$element);
            }

            focusLeft = prevLeft;
            focusWidth = prevWidth + lastWidth;
        }

        // console.log('FOCUS', 'x:'+focusLeft, 'width:'+focusWidth);

        // la cible dépasse sur la droite
        if (focusLeft + focusWidth > winLeft + winWidth) {
            // console.log('#### RIGHT');
            var i = 0
            var n = breaks.length;
            var focusPoint = 0;
            var point, diff;
            for (; i < n; i++) {
                point = breaks[i];
                diff = focusLeft - point;
                // console.log('---', point, diff + focusWidth);
                if (diff < 0) break;
                focusPoint = point;
                if (diff + focusWidth < winWidth) break;
            }
            // console.log('#### SCROLL:', focusPoint);
            this.layout.scroll.to(focusPoint - this.layout.options.leftWidth);
        }
        // la cible dépasse à gauche
        else if (focusLeft < winLeft) {
            // console.log('#### LEFT');
            // console.log('#### SCROLL:', focusPoint);
            this.layout.scroll.to(focusLeft - this.layout.options.leftWidth);
        }
        // si on a plusieurs pages mais qu'on voit le menu...
        else if (state.length > 1 && winLeft < firstLeft) {
            this.layout.scroll.to(firstLeft - this.layout.options.leftWidth);
        }

        function getPageWidth($page) {
            var width = 0;
            var $section/*, $contentEnd*/;

            $page.find('.section').each(function(i, section) {
                $section = $(section);
                if ($section.is(':has(.js-scuba__section__content .js-scuba__section__body)')) {
                    width += $section.find('.js-scuba__section__content .js-scuba__section__body').outerWidth();
                } else {
                    width += $section.outerWidth();
                }
            });

            return width;
        }

        /*if (state.length < 2) {
            this.layout.scroll.to(0);
        } else {
            var last = _.last(state);
            var prev = _.last(state, 2)[0];
            // if (prev.$element.offset().left)
            // console.log('$:', $(document.body).scrollLeft(), event);
            this.layout.scroll.to(prev.$element.offset().left - first.$element.offset().left);
            this.collapse();
            // this.layout.scroll.to(prev.$element.offset().left - first.$element.offset().left);
        }*/
    },

    _nextPagesChangedHandler: function(/*event, nextPages*/) {
        /*if (nextPages.length > 0) {
            if (nextPages[0].$element.is(':has(.dgt-full)')) {
                this.collapse();
            }
        }*/
    },

    isCollapsed: function() {
        return this._isCollapsed;
    },

    expand: function() {
        if (!this._isCollapsed) return;

        this._isCollapsed = false;

        this.$head.removeClass('is-collapsed');
        this.$head.find('.js-scuba__root').off('click', $.proxy(this.expand, this));
        this.$head.trigger('scuba:expand');
        this.menu.openCurrentState();
    },

    collapse: function() {
        if (this._isCollapsed) return;

        this._isCollapsed = true;

        this.$head.addClass('is-collapsed');
        this.$head.find('.js-scuba__root').on('click', $.proxy(this.expand, this));
        this.$head.trigger('scuba:collapse');
        this.menu.closeAll();
    },

});



/* --------------------------------------------------

    GESTIONNAIRE DE L'OVERLAY

-------------------------------------------------- */

/**
 * Gère l'affichage de l'overlay sur le contenu lorsque
 * le menu est en exploration et l'affichage
 */
var MenuOverlay = function(layout) {
    this.layout = layout;
};

$.extend(MenuOverlay.prototype, {

    activate: function() {
        // variables
        this._isOpened = false;
        this._isAnimating = false;

        // éléments du dom
        this.$window = $(window);
        this.$body = $(document.body);
        this.$head = $('.js-scuba__head').first();
        this.$menu = this.$head.find('.js-scuba__menu').first();
        this.menu = this.$menu.data('ScubaMenuController');

        // éléments créés
        this.$overlay = $('<div id="overlay"></div>');

        // écouteurs
        this.$menu.on('submenuOpened', $.proxy(this._menu_submenuOpenHandler, this));
        this.$menu.on('allSubmenuClosed', $.proxy(this._menu_allSubmenuClosedHandler, this));
        this.$overlay.on('click', $.proxy(this._overlay_clickHandler, this));
        this.$window.on('scuba:pushState', $.proxy(this._pushStateHandler, this));
    },

    deactivate: function() {
        this.$overlay.detach();

        this.$menu.off('submenuOpened', $.proxy(this._menu_submenuOpenHandler, this));
        this.$menu.off('allSubmenuClosed', $.proxy(this._menu_allSubmenuClosedHandler, this));
        this.$overlay.off('click', $.proxy(this._overlay_clickHandler, this));
        this.$window.off('scuba:pushState', $.proxy(this._pushStateHandler, this));
    },

    _overlay_clickHandler: function(event) {
        event.preventDefault();
        event.stopPropagation();

        this.hide();

        this.menu.openCurrentState();
    },

    _menu_submenuOpenHandler: function() {
        this.show();

        // TODO: Fix de l'ouverture des sous menu
        if (this.menu.isWalking) {
            var $lastSubmenu = this.menu.$sections.last();
            var $firstLink = $lastSubmenu.find('.js-scuba__menu a:eq(0)');
            $firstLink.click();
        }
    },

    _menu_allSubmenuClosedHandler: function() {
        this.hide();
    },

    _pushStateHandler: function() {
        this.hide();
    },

    show: function() {
        return; // TODO: Fix de l'ouverture des sous menu
        /*if (this._isAnimating || this._isOpened) return;

        this._isAnimating = true;
        this._isOpened = true;

        this.$overlay.addClass('oj-enter').appendTo(this.$body);

        var self = this;
        setTimeout(function(){
            self.$overlay.addClass('oj-enter-active');
            setTimeout(function() {
                self.$overlay.removeClass('oj-enter oj-enter-active');
                self._isAnimating = false;
            }, 350);
        }, 10);*/
    },

    hide: function() {
        return; // TODO: Fix de l'ouverture des sous menu
        /*if (this._isAnimating || !this._isOpened) return;

        this._isAnimating = true;

        this.$overlay.addClass('oj-leave');

        var self = this;
        setTimeout(function() {
            self.$overlay.addClass('oj-leave-active');
            setTimeout(function() {
                self.$overlay.detach().removeClass('oj-leave oj-leave-active');
                self._isOpened = false;
                self._isAnimating = false;
            }, 350);
        }, 10);*/
    },

});



/* --------------------------------------------------

    GESTIONNAIRE DU MENU

-------------------------------------------------- */

/**
 * Gère l'affichage des masques sur les sections du menu principal.
 */
var Menu = function(layout) {
    this.layout = layout;
};

$.extend(Menu.prototype, {

    activate: function() {
        // éléments du dom
        this.$window = $(window);
        this.$head = $('.js-scuba__head').first();
        this.$menu = this.$head.find('.js-scuba__menu').first();
        this.$menuSection = this.$menu.closest('.js-scuba__section');
        this.menu = this.$menu.data('ScubaMenuController');
        $.proxy(this._scrollHandler, this);
        // écouteurs
        this.$window.on('scroll', $.proxy(this._scrollHandler, this));
    },

    deactivate: function() {
        this.$window.off('scroll', $.proxy(this._scrollHandler, this));
        this.$menuSection.add(this.menu.$sections.get())
            .off('click', $.proxy(this._sectionOverflow_clickHandler, this));
    },

    /**
     * Lorsque la page est scrollée, vérifie pour chaque section si
     * elle est dépasse à gauche ou non. Ceci pour en modifier
     * l'affichage et le comportement.
     */
    _scrollHandler: function() {
        // défilement actuel
        var scrollLeft = this.layout.scroll.scrollLeft();

        // liste de toutes les sections du #head (sans avoir à les requêter)
        var sections = _.union(this.$menuSection.get(), this.menu.$sections.get());

        // Rémi : position calculé par l'addition des largeurs afin d'éviter de
        // demander leur offset().left... je présume que c'est plus performant.
        var offsetLeft = 0;

        var $section, sectionWidth, isOverflow, isHalfOverflow;
        _.each(sections, function(section/*, i*/) {
            $section = $(section);
            sectionWidth = $section.outerWidth();

            // détermine si la section dépasse
            isOverflow = scrollLeft > offsetLeft;
            isHalfOverflow = scrollLeft > offsetLeft + sectionWidth * 0.5;

            // ne fait rien si rien n'a changé...
            if (section.__lytHo_isOverflow !== isOverflow) {
                section.__lytHo_isOverflow = isOverflow;

                // modifie la classe
                $section.toggleClass('is-overflow', section.__lytHo_isOverflow);


                // ajoute/retire l'écouteur
                if (section.__lytHo_isOverflow) {
                    $section.on('click', $.proxy(this._sectionOverflow_clickHandler, this));
                } else {
                    $section.off('click', $.proxy(this._sectionOverflow_clickHandler, this));
                }
            }

            if (section.__lytHo_isHalfOverflow !== isHalfOverflow) {
                section.__lytHo_isHalfOverflow = isHalfOverflow;
                // modifie la classe
                $section.toggleClass('is-half-overflow', section.__lytHo_isHalfOverflow);
            }

            // incrémente de la largeur de la section pour les suivantes
            offsetLeft += sectionWidth;

        }, this);
    },

    _sectionOverflow_clickHandler: function() {
        this.layout.scroll.to(0);
    },

});




/* --------------------------------------------------

    FLECHES DE NAVIGATION

-------------------------------------------------- */

var Arrows = function(layout) {
    this.layout = layout;
};

$.extend(Arrows.prototype, {

    activate: function() {
        this._leftIsVisible = false;
        this._rightIsVisible = true;

        // éléments du dom
        this.$window = $(window);
        this.$body   = $(document.body);
        this.$head   = $('.js-scuba__head');
        this.$main   = $('.js-scuba__main');

        // éléments à ajouter
        var DHEAD_TEMPLATE =
              '<div class="c-scuba-dhead js-scuba__dhead">'+
                '<div class="c-scuba-header__toggles">'+
                  '<a href="#" class="c-scuba-header__toggle c-scuba-header__toggle--menu js-scuba__dhead__left-toggle"></a>'+
                '</div>'+
                '<div class="js-scuba__dhead__right is-visible"></div>'+
                '<a href="#" class="js-scuba__dhead__left-logo"></a>'+
                '<a href="#" class="c-scuba-header__arrow js-scuba__dhead__left-arrow"></a>'+
                '<a href="#" class="c-scuba-header__left-backgd js-scuba__dhead__left-bg"></a>'+
              '</div>';

        var $dhead = $("[data-dhead-template]").first();
        if($dhead.length){
          DHEAD_TEMPLATE = $dhead.html();
        }
        this.$dhead = $(DHEAD_TEMPLATE);
        this.$dhead.appendTo(this.$head);

        this.$right = this.$dhead.find(".js-scuba__dhead__right").first();
        this.$leftLogo = this.$dhead.find(".js-scuba__dhead__left-logo").first();
        this.$leftArrow = this.$dhead.find(".js-scuba__dhead__left-arrow").first();
        this.$leftToggle = this.$dhead.find(".js-scuba__dhead__left-toggle").first();
        this.$leftBackgd = this.$dhead.find(".js-scuba__dhead__left-bg").first();
        this.$scrollOverlay = $('<div id="scroll-overlay"></div>');

        // écouteurs
        this.$head.on('scuba:expand',   $.proxy(this.hideLeft, this));
        this.$head.on('scuba:collapse', $.proxy(this.showLeft, this));
        this.$head.on('scuba:nextPagesChanged', $.proxy(this._invalidateArrowsHandler, this));
        this.$window.on('scroll resize',  $.proxy(this._invalidateArrowsHandler, this));

        this.$leftLogo.on('click', $.proxy(this._menuButtonClickHandler, this));
        this.$leftToggle.on('click', $.proxy(this._menuButtonClickHandler, this));
        this.$leftBackgd.on('click', $.proxy(this._prevButtonClickHandler, this));
        this.$leftArrow.on('click', $.proxy(this._prevButtonClickHandler, this));
        this.$right.on('click', $.proxy(this._nextButtonClickHandler, this));

        // init
        this._invalidateArrowsHandler();
    },

    deactivate: function() {
        // éléments à ajouter
        this.$dhead.remove();
        this.$scrollOverlay.remove();

        // évènements
        this.$head.off('scuba:expand',   $.proxy(this.hideLeft, this));
        this.$head.off('scuba:collapse', $.proxy(this.showLeft, this));
        this.$head.off('scuba:nextPagesChanged', $.proxy(this._invalidateArrowsHandler, this));
        this.$window.off('scroll resize',  $.proxy(this._invalidateArrowsHandler, this));
    },


    _menuButtonClickHandler: function(event) {
        event.preventDefault();
        event.stopPropagation();

        this.gotoMenu();
    },

    _prevButtonClickHandler: function(event) {
        event.preventDefault();
        event.stopPropagation();

        this.gotoPrevPage();
    },

    _nextButtonClickHandler: function(event) {
        event.preventDefault();
        event.stopPropagation();

        this.addScrollOverlay();
        this.layout.scroll.to(this.layout.scroll.scrollLeft() + this.$window.width() * 0.6);
    },

    _invalidateArrowsHandler: function(/*event*/) {
        if (!this.layout.scroll) return;

        var scrollLeft = this.layout.scroll.scrollLeft();
        var maxScrollLeft = this.layout.scroll.maxScrollLeft();

        // TODO : attention, c'est peut-être lourd en ressources :(
        var hasContentNotOverflow = this.$main.find('js-scuba__page:last-child .js-scuba__section__content:not(.is-overflow)').length > 0;

        if (scrollLeft < maxScrollLeft - 5 && !hasContentNotOverflow) {
            this.showRight();
        } else {
            this.hideRight();
        }
    },


    showLeft: function() {
        if (this._leftIsVisible) return;
        // console.log('showLeft');
        this._leftIsVisible = true;

        // this.$left.addClass('is-visible');
    },

    hideLeft: function() {
        if (!this._leftIsVisible || this.layout.head.isCollapsed()) return;
        // console.log('hideLeft');
        this._leftIsVisible = false;

        // this.$left.removeClass('is-visible');
    },

    showRight: function() {
        if (this._rightIsVisible) return;
        // console.log('showRight');
        this._rightIsVisible = true;

        this.$right.addClass('is-visible');
    },

    hideRight: function() {
        if (!this._rightIsVisible) return;
        // console.log('hideRight');
        this._rightIsVisible = false;

        this.$right.removeClass('is-visible');
    },

    gotoMenu: function() {
        // this.layout.head.expand();
        this.layout.scroll.to(0);
    },

    gotoPrevPage: function() {
        var scrollLeft = this.layout.scroll.scrollLeft();
        if (scrollLeft <= 0) {
            this.gotoMenu();
        } else {
            var $pages = this.$main.find('.js-scuba__page:not(:has(.section-cover))');

            // inverse les éléments
            $pages = $($pages.get().reverse());

            // cherche la page
            var scroll = 0;
            var $page, pageOffset;
            _.find($pages.get(), function(page) {
                $page = $(page);
                pageOffset = $page.offset().left - this.layout.options.leftWidth;
                if (pageOffset < scrollLeft) {
                    scroll = pageOffset;
                    return true; // équivalent de break
                }
            }, this);

            this.layout.scroll.to(scroll);
        }
    },

    addScrollOverlay: function() {
        var scrollLeft = this.layout.scroll.scrollLeft();
        var windowWidth = this.$window.width();
        var scrollWidth = this.layout.scroll.documentWidth();

        var $overlay = this.$scrollOverlay;

        $overlay.css({
            width: (scrollWidth - windowWidth - scrollLeft)+'px',
            marginLeft: scrollLeft + windowWidth,
        });
        $overlay.removeClass('oj-leave oj-leave-active')
        $overlay.appendTo(this.$body);

        setTimeout(function(){
            $overlay.addClass('oj-leave');
            setTimeout(function(){
                $overlay.addClass('oj-leave-active');
                setTimeout(function(){
                    $overlay.removeClass('oj-leave oj-leave-active').detach();
                }, 350);
            }, 1);
        }, 600);
    },

});

export default HorizontalLayout;


// WEBPACK FOOTER //
// ./scripts/scuba/HorizontalLayout.js